import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import "./InfoTile.css";
import externalLink from "../../../resources/icons/external-link.svg";

type InfoTileProps = {
  currentVersion?: string;
  latestVersion?: string;
  homeUrl: string;
  children?: React.ReactNode;
};

/** A tile with additional information on an application */
function InfoTile({
  currentVersion,
  latestVersion,
  homeUrl,
  children,
}: InfoTileProps) {
  const {formatMessage} = useIntl();
  const hostName = typeof homeUrl === "string" ? homeUrl.split("/")[2] : "…";

  return (
    <div className="infoTile">
      <div>
        {currentVersion && (
          <div className="infoTile__content">
            <b>
              <FormattedMessage id="appDetails.infoTile.version.current" />
            </b>
            {currentVersion}
          </div>
        )}

        {latestVersion && (
          <div className="infoTile__content">
            <b>
              <FormattedMessage id="appDetails.infoTile.version.latest" />
            </b>
            {latestVersion}
          </div>
        )}

        <div className="infoTile__content">
          <b>
            <FormattedMessage id="appDetails.infoTile.home" />
          </b>
          <a
            className="infoTile__externalUrl"
            href={homeUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={formatMessage(
              {id: "general.link.ariaLabel.external"},
              {name: hostName},
            )}
          >
            <p>{hostName}</p>
            <img src={externalLink} alt="" width={12} height={12} />
          </a>
        </div>
      </div>

      {/* Action buttons or other content passed as children */}
      {children}
    </div>
  );
}

export default InfoTile;
